import { InjectorHelper } from 'invision-core';
export var generateTitle = function generateTitle(giftCard) {
  if (giftCard && giftCard.Amount) {
    var $filter = InjectorHelper.getFilterService();
    var displayAmount = $filter('invCurrency')(giftCard.Amount, giftCard.Currency);
    var id = null;
    if (giftCard.RecipientEmail) {
      id = giftCard.RecipientEmail;
    } else if (giftCard.ProviderCode && giftCard.AccountNumber) {
      //The existence of ProviderCode tells us we have a physical gift card
      id = giftCard.AccountNumber;
    }
    return "".concat(id, " - ").concat(displayAmount);
  }
  return '';
};
export var getCreationDate = function getCreationDate(giftCard) {
  if (giftCard) {
    var notifications = giftCard.SentNotifications;
    if (notifications && notifications.length > 0) {
      return notifications[0].Notified;
    }
  }
  return null;
};